// extracted by mini-css-extract-plugin
export default {"fullscreen":"report-section-fullscreen_fullscreen__ABO-s","icon":"report-section-fullscreen_icon__UJnJz","placeHolderShimmer":"report-section-fullscreen_placeHolderShimmer__eVSB7"};